import { PostMessageParentConnection } from './connection'

export const connection = new PostMessageParentConnection()
